import { create } from 'zustand';
import { getMosruInformation } from '../../../api/api';
import { toast } from 'react-toastify';

export const useMosruStore = create((set, get) => ({
  data: null,
  modal: false,
  setModal: (modal) => set(() => ({ modal })),
  loading: true,

  getInfoFromMosru: async (objectId) => {
    set({ loading: true });
    await getMosruInformation(
      objectId,
      (data) => {
        set({ loading: false, data, modal: true });
      },
      (err) => {
        set({ loading: false, data: null });
        toast.error(err?.error || 'Ошибка при получении данных');
      }
    );
  },
}));
